export const REFRESH_LOCK_KEY = 'admin-area-token-refresh';
